import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterObjectifProByNamePipe } from 'src/app/shared/pipes/filter-objectifPro-by-name/filter-objectifPro-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ObjectifProModalDetailComponent } from './modal/objectifPro-modal-detail/objectifPro-modal-detail.component';
import { ObjectifProModalAjoutComponent } from './modal/objectifPro-modal-ajout/objectifPro-modal-ajout.component';
import { ListObjectifProComponent } from './list-objectifPro/list-objectifPro.component';

@NgModule({
	declarations: [
		ListObjectifProComponent,
		ObjectifProModalDetailComponent,
		ObjectifProModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterObjectifProByNamePipe]
})

export class ObjectifProModule {}
